<template>
  <div class="row">
    <div class="col-md-12 text-left">
      <modal :show.sync="ModalOrderDespachador">
        <template slot="header">
          <h5 class="modal-title sub_title" id="exampleModalLabel">Asignar despachador a ordenes masivamente</h5>
        </template>
        <div class="container">
          <div class="container-fluid">
            <div class="row">
              <div class="radio-default-acre col-12">
                <PrettyRadio name="modo" v-model="modo" :value="false">Rango de ordenes</PrettyRadio>
                <PrettyRadio name="modo" v-model="modo" :value="true">Ordenes especificas</PrettyRadio>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-4" v-show="modo === false">
                <label>Orden Inicial</label>
                <base-input type="number" :min="0" v-model="num1">
                </base-input>
              </div>
              <div class="col-4" v-show="modo === false">
                <label>Orden Final</label>
                <base-input type="number" :min="num1" v-model="num2">
                </base-input>
              </div>
              <div class="col-4" v-show="modo === true">
                <label>Ordenes</label>
                <draggable class="list-group drag" :list="orders" group="order">
                  <div class=" list-group-item" v-for="(element,index) in orders" :key="index">
                    {{ 'Orden # ' + element.order_id + ', Estado: ' + element.OrderStatus.status }}
                  </div>
                </draggable>
              </div>
              <div class="col-4" v-show="modo === true">
                <label>Arrastrar ordenes para actualizar</label>
                <draggable class="list-group drag" :list="ordersupdate" group="order">
                  <div class=" list-group-item" v-for="(element,index) in ordersupdate" :key="index">
                    {{ 'Orden # ' + element.order_id + ', Estado: ' + element.OrderStatus.status }}
                  </div>
                </draggable>
              </div>
              <div class="col-4">
                <label class="typo__label">Despachador</label>
                <multiselect
                    v-model="userselect"
                    :custom-label="customLabel"
                    :searchable="true"
                    :close-on-select="true"
                    :multiple="true"
                    track-by="user_id" label="last_name"
                    placeholder="Seleccione un despachador"
                    :options="users"
                >
                  <template slot="singleLabel" slot-scope="{ option }">
                    <strong>{{ option.name + ' ' + option.last_name }}</strong>
                  </template>
                </multiselect>
              </div>
              <div class="col-12 mt-3 text-center">
                <base-button class="btn_submit" @click="update">Guardar</base-button>
                <base-alert type="danger" v-if="error">
                  <strong>{{ error }}</strong>
                </base-alert>
              </div>
            </div>

          </div>

        </div>
        <template slot="footer">
        </template>
        <div class="row">
          <div class="col-12">
            <base-progress v-show="progress > 0" type="success" :height="8" :value="progress"
                           label="Guardando"></base-progress>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>


<script>
import {bus} from "@/components/Order/bus-order";
import {order_service} from "@/services/order/OrderService";
import swal from "sweetalert";
import PrettyRadio from 'pretty-checkbox-vue/radio';
import draggable from 'vuedraggable'

export default {
  name: "ModalOrderDespachador",
  components: {PrettyRadio, draggable},
  data() {
    return {
      error: '',
      ModalOrderDespachador: false,
      progress: 0,
      orderstatus: [],
      status: [],
      users: [],
      userselect: [],
      user_session: [],
      num1: 0,
      num2: 0,
      orders: [],
      ordersupdate: [],
      modo: false
    }
  },
  methods: {
    customLabel({name, last_name}) {
      return `${name} ${last_name}`
    },
    update() {
      if (this.modo === false) {
        if (Number(this.num1) <= Number(this.num2)) {
          this.progress = 50
          this.error = ''
          const order_user = []
          for (const us in this.userselect) {
            order_user.push({"user_id": this.userselect[us].user_id})
          }
          let data = {
            state: 6,
            r1: Number(this.num1),
            r2: Number(this.num2),
            User: order_user,
            user_id: this.user_session.user_id
          }
          order_service.OrderStatusMAsivo(data)
          //console.log(data)
        } else {
          this.error = 'Seleccionar despachador y ingresar la orden inicial y final para la actualización'
        }
      } else if (this.modo === true) {
        if (this.userselect.length > 0 && this.ordersupdate.length > 0) {
          this.progress = 50
          this.error = ''
          let data = []
          //console.log(this.ordersupdate)
          //console.log(this.userselect)
          for (const prop in this.ordersupdate) {
            const order_user = []
            //agregar usuarios existentes en la orden
            if (this.ordersupdate[prop].User.length > 0) {
              for (const u in this.ordersupdate[prop].User) {
                order_user.push({"user_id": this.ordersupdate[prop].User[u].user_id})
              }
            }
            for (const us in this.userselect) {
              order_user.push({"user_id": this.userselect[us].user_id})
            }

            data.push({
              'OrderStatus': {'order_status_id': 6},
              'order_id': Number(this.ordersupdate[prop].order_id),
              'User': order_user,
              'user_id': this.user_session.user_id
            })
          }
          order_service.UpdateOrderStatus(data)
          //console.log(data)
        } else {
          this.error = 'Seleccionar despachador y arrarstrar una orden para actualziar'
        }
      }

    },
    cleandatafull() {
      this.num1 = 0
      this.num2 = 0
      this.status = []
      this.progress = 0
      this.ordersupdate = []
      this.userselect = []
      this.ModalOrderDespachador = false
      order_service.GetAllOrder()
    }
  },
  created() {
    this.user_session = JSON.parse(sessionStorage.getItem('user'))
    order_service.GetAllOrderStatusBy({'st': '1'})
    order_service.GetUsersByType(4)
    bus.$on('ShowOrderDespachador', () => {
      this.ModalOrderDespachador = true
    })
    bus.$on('GetUsersByType', (response => {
      //console.log(response)
      this.users = response
    }))

    bus.$on('GetAllOrderStatusBy', (response) => {
      this.orders = response
    })
    bus.$on('OrderStatusMAsivo', (response) => {
      if (response.statusText === 'Created') {
        this.progress = 100
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Actualizado El Rango De Ordenes Seleccionadas",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Actualizar Las Ordenes. Intenta Nuevamente",
          button: "Aceptar"
        })
      }
    })
    bus.$on('ResponseUpdateOrderStatus', (response) => {
      if (response.status === 200) {
        this.progress = 100
        this.cleandatafull()
        swal({
          icon: "success",
          text: "Se Ha Actualizaron Las Ordenes Seleccionadas",
          button: "Aceptar"
        })
      } else {
        this.progress = 100
        this.cleandatafull()
        swal({
          dangerMode: true,
          icon: "error",
          text: "No Fue Posible Actualizar Las Ordenes. Intenta Nuevamente",
          button: "Aceptar"
        })
      }
    })
  }
}
</script>

<style scoped>
.drag {
  border: 1px solid;
  padding: 0px;
  border-radius: 6px;
  height: 300px;
  overflow: auto;
}
</style>
